@if (cellValue != null && fontValue != null) {
    <div class="dropdown-wrapper" appMousedownOutside (mousedownOutside)="el.hidden = true" appScrollToChild>
        <div class="select-component" (click)="el.hidden = !el.hidden">
            <div class="selected-list">
                <span
                    class="font-cell-color"
                    [style.background]="cellValue"
                    [style.color]="fontValue"
                >
                    $387,271.54
                </span>
            </div>

            <span class="icon-arrow-down"></span>
        </div>

        <div class="dropdown" #el [hidden]=true>
            <ul class="cell-font-colors">
                @for (item of cellAndFontColors; track $index) {
                    <li
                        (click)="onCellFontColorSelected(item, el)"
                        [style.background]="item.cellColor"
                        [style.color]="item.fontColor"
                    >
                        <span>$387,271.54</span>
                    </li>
                }
            </ul>
        </div>
    </div>
}
